// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"6a6ac76d","705":"15706a12"}[chunkId] + ".chunk.js";
};